module.exports = __webpack_public_path__ + "img/evm.63261795.png";